// extracted by mini-css-extract-plugin
module.exports = {"container":"e_0tb","dots":"e_1tb","dot":"e_2tb","dotActive":"e_3tb","buttons":"e_4tb","button":"e_5tb","arrow":"e_6tb","rotated":"e_7tb"};